import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EyeSightService {
  public status$ = new BehaviorSubject<boolean>(this.enabled);

  private _enabled = false;
  public get enabled() {
    return this._enabled;
  }
  public set enabled(value) {
    this._enabled = value;

    localStorage.setItem('eye', value ? 'on' : 'off');
    this.status$.next(value);

    value
      ? document.body.classList.add('eye')
      : document.body.classList.remove('eye');
  }

  constructor() {
    this.enabled = localStorage.getItem('eye') === 'on' ? true : false;
  }

  public enable() {
    this.enabled = true;
  }

  public disable() {
    this.enabled = false;
  }
}
